import { render, staticRenderFns } from "./bjxx.vue?vue&type=template&id=3d233aba&scoped=true"
import script from "./bjxx.vue?vue&type=script&lang=js"
export * from "./bjxx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d233aba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d233aba')) {
      api.createRecord('3d233aba', component.options)
    } else {
      api.reload('3d233aba', component.options)
    }
    module.hot.accept("./bjxx.vue?vue&type=template&id=3d233aba&scoped=true", function () {
      api.rerender('3d233aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hsycjkequipmentmanagement/components/bjxx.vue"
export default component.exports